import { Avatar } from '@robinpowered/ui-kit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@awesome.me/kit-cf858715fd/icons/classic/solid';
import { CSSProperties } from 'react';

type Props = {
  name?: string | null;
  avatar?: string | null;
  style?: CSSProperties;
};

export const RobinAvatar = ({ avatar, name, style }: Props) => {
  return (
    <>
      {avatar ? (
        <Avatar
          size={'small'}
          src={avatar}
          name={name || ''}
          alt={name || ''}
          data-testid="avatar-with-image"
          style={{ minWidth: 24, ...style }}
        >
          <FontAwesomeIcon icon={faUser} />
        </Avatar>
      ) : name ? (
        <Avatar
          size={'small'}
          name={name}
          alt={name || ''}
          data-testid="avatar-with-name"
          style={style}
        />
      ) : (
        <Avatar
          size={'small'}
          icon={<FontAwesomeIcon icon={faUser} />}
          alt={name || ''}
          data-testid="avatar-with-icon"
          style={style}
        />
      )}
    </>
  );
};
